import * as React from 'react';
import { ApolloProvider } from '@apollo/client';
import { FeatureFlagsContext, SiteUrlsContext, useRenderLabels, UseRenderLabelsParams } from '@tableau/catalog-ui-temp';
import { SiteUrls } from '@tableau/shared-urls';
import { RestApiServiceParamsContext } from '@tableau/vizportalclient-common-components';
import { catalogApolloClient } from '../../Catalog/CatalogApolloClient';
import { LabelIconStyle } from '../../../utils/DataCatalogUtils';
import { catalogFeatureFlagsAdapter } from '../../Catalog/CatalogFeatureFlags';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export type LabelWrapperProps = {
  readonly params: UseRenderLabelsParams;
};

export function LabelWrapper(props: UseRenderLabelsParams, urls: SiteUrls, siteLuid: string): JSX.Element {
  return (
    <RestApiServiceParamsContext.Provider value={{ siteLuid }}>
      <SiteUrlsContext.Provider value={urls}>
        <FeatureFlagsContext.Provider value={catalogFeatureFlagsAdapter()}>
          <QueryClientProvider client={new QueryClient()}>
            <ApolloProvider client={catalogApolloClient}>
              <LabelWrapperInner {...props} />
            </ApolloProvider>
          </QueryClientProvider>
        </FeatureFlagsContext.Provider>
      </SiteUrlsContext.Provider>
    </RestApiServiceParamsContext.Provider>
  );
}

function LabelWrapperInner(props: UseRenderLabelsParams): JSX.Element {
  const { certifications, warnings } = useRenderLabelsWrapper(props);

  return (
    <div className={LabelIconStyle}>
      {certifications}
      {warnings}
    </div>
  );
}

export function useRenderLabelsWrapper(params: UseRenderLabelsParams) {
  return useRenderLabels(params);
}
